import { NgModule } from "@angular/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { BrMaskerModule } from "brmasker-ionic-3";
import { IonicPageModule } from "ionic-angular";
import { TruncateModule } from "ng2-truncate";
import { CommonComponentsModule } from "../../../../components/common/common-components.module";
import { ComponentsModule } from "../../../../components/components.module";
import { CompanyPageModule } from "../../company.module";
import { CompanyDetailsPageModule } from "../../locations/locations.module";
import { WorkgroupPermissions } from "../permissions/workgroup-permissions";
import { WorkgroupGeneralDetails } from "../workgroup-general-details/workgroup-general-details";
import { WorkgroupPermissionDetail } from "./workgroup-permission-details";

@NgModule({
  declarations: [
    WorkgroupPermissionDetail,
    WorkgroupPermissions,
    WorkgroupGeneralDetails,
  ],
  imports: [
    CommonComponentsModule,
    IonicPageModule.forChild(WorkgroupPermissionDetail),
    TranslateModule,
    ComponentsModule,
    CompanyPageModule,
    NgSelectModule,
    CompanyDetailsPageModule,
    TruncateModule,
  ],
  exports: [BrMaskerModule],
})
export class WorkgroupPermissionDetailModule {}



// WEBPACK FOOTER //
// ./src/pages/company/company-details/workgroup-permission-details/workgroup-permission-details.module.ts